(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
  shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom,
  newCustomerCampaignAtom = _svs$lyckoplatsen$com.newCustomerCampaignAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.react.components,
  BetslipConfirm = _svs$lyckoplatsen$com2.BetslipConfirm,
  BetslipConfirmCampaign = _svs$lyckoplatsen$com2.BetslipConfirmCampaign,
  BetslipDetails = _svs$lyckoplatsen$com2.BetslipDetails,
  BetslipDetailsCampaign = _svs$lyckoplatsen$com2.BetslipDetailsCampaign,
  BetslipHeader = _svs$lyckoplatsen$com2.BetslipHeader;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const Betslip = () => {
  const _useState = useState('0px'),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  const refBetslipBody = useRef(null);
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const charity = useAtomValue(charityAtom);
  const campaign = useAtomValue(newCustomerCampaignAtom);
  const updateHeight = useCallback(() => {
    if (!shouldShowPin) {
      setHeight("0px");
    } else if (refBetslipBody.current) {
      const newHeight = "".concat(refBetslipBody.current.scrollHeight, "px");
      if (height !== newHeight) {
        setHeight(newHeight);
      }
    }
  }, [shouldShowPin, height]);
  useEffect(() => {
    updateHeight();
  }, [shouldShowPin, updateHeight]);
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        updateHeight();
      });
    });
    if (refBetslipBody.current) {
      observer.observe(refBetslipBody.current);
    }
    return () => {
      if (refBetslipBody.current) {
        observer.unobserve(refBetslipBody.current);
      }
    };
  }, [updateHeight]);
  useEffect(() => {
    if (isSelfService && svs.components.selfserviceCart && svs.components.selfserviceCart.getCartInstance) {
      var _svs$components$selfs;
      (_svs$components$selfs = svs.components.selfserviceCart) === null || _svs$components$selfs === void 0 || (_svs$components$selfs = _svs$components$selfs.getCartInstance()) === null || _svs$components$selfs === void 0 || _svs$components$selfs.setGameCallback(() => {
        if (!locationConfirmed && shouldShowPin) {
          return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
        }
        return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
      });
    }
  }, [locationConfirmed, shouldShowPin]);
  return React.createElement("div", {
    className: "lp-play-betslip \n          ".concat(shouldShowPin ? 'betslip-show-shadow' : 'betslip-hide-shadow', "\n          ").concat(charity ? 'has-charity' : '', "\n          ").concat(campaign.isActive ? 'has-campaign' : ''),
    style: {
      height: shouldShowPin ? height : 0
    }
  }, React.createElement("div", {
    className: "lp-betslip-body",
    ref: refBetslipBody
  }, React.createElement(BetslipHeader, null), !locationConfirmed && (campaign.isActive ? React.createElement(BetslipConfirmCampaign, null) : React.createElement(BetslipConfirm, null)), locationConfirmed && (campaign.isActive ? React.createElement(BetslipDetailsCampaign, null) : React.createElement(BetslipDetails, null))));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Betslip
});

 })(window);